import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper, IconButton} from 'material-ui';
import Loading from "../../common/Loading/Loading";
import Error from "../../common/Error/Error";
import ReportSubject from '../ReportSubject/ReportSubject';
import style from "../../../styles/styles";
import {deleteReportSubject, getReportSubjects} from "../../../store/reportsubjects/actions";
import {connect} from "react-redux";
import {FlatButton, Dialog} from "material-ui";
import ContentAdd from 'material-ui/svg-icons/content/add';
import {white} from "material-ui/styles/colors";
import {Link} from "react-router-dom";
import withTranslation from "../../../hoc/withTranslation";
import {ADD_REPORTSUBJECT_PAGE} from "../../../constants/routes";

export class SmartReportSubjectList extends React.Component {

    static propTypes = {
        title: PropTypes.string
    };

    state = {
        reportSubjectToRemove: null,
        openRemoveReportSubject: false
    };

    componentWillMount() {
        this.props.getReportSubjects(this.props.app.id);
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.sending && !nextProps.sending) {
            if (this.state.reportSubjectToRemove) { // admin has been added
                this.handleCloseReportSubject()
            }
        }
    }

    // Delete reportSubject

    handleDeleteReportSubject = (reportSubject) => {
        this.setState({
            openRemoveReportSubject: true,
            reportSubjectToRemove: reportSubject
        });
    };

    handleCloseReportSubject = () => {
        this.setState({
            openRemoveReportSubject: false,
            reportSubjectToRemove: null
        });
    };

    deleteReportSubject = () => {
        this.props.deleteReportSubject(this.props.app.id, this.state.reportSubjectToRemove.id);
    };

    // Render

    renderDeleteReportSubjectDialog(reportSubject) {
        let actions = [
            <FlatButton
                label={this.props.t('generic.cancel')}
                disabled={this.props.sending}
                onClick={this.handleCloseReportSubject}
            />,
            <FlatButton
                label={this.props.t('generic.delete')}
                primary={true}
                disabled={this.props.sending}
                onClick={this.deleteReportSubject}
            />
        ];

        return (
            <Dialog actions={actions}
                    modal={this.props.sending}
                    open={this.state.openRemoveReportSubject}
                    onRequestClose={this.handleCloseReportSubject}>
                {this.props.sending && <Loading paper={false}/>}
                {!this.props.sending &&
                <p>
                    <div dangerouslySetInnerHTML={{
                        __html:
                            this.props.t('settings_page.remove_reportSubject_confirmation', {name: reportSubject.name})
                    }}/>
                </p>
                }
            </Dialog>
        );
    }

    render() {
        const {loading, reportSubjects, title, user, app} = this.props;

        let content;

        if (loading) {
            content = <Loading paper={false}/>;
        } else if (reportSubjects.length === 0) {
            content =
                <Error
                    title="No data"
                    subtitle="Add some reportSubjects"
                />
        } else {
            content = reportSubjects.map((reportSubject, index) => {
                return (
                    <div key={reportSubject.id}>
                        <ReportSubject
                            app={app}
                            reportSubject={reportSubject}
                            user={user}
                            handleRemoveReportSubject={this.handleDeleteReportSubject}
                        />
                        {index !== (reportSubjects.length - 1) && <Divider inset={true}/>}
                    </div>
                )
            })
        }

        return (
            <div>
                {this.state.reportSubjectToRemove && this.renderDeleteReportSubjectDialog(this.state.reportSubjectToRemove)}
                <Paper>
                    <List>
                        <Subheader style={{...style.subHeader, ...style.relative}}>
                            {title}
                            <Link to={ADD_REPORTSUBJECT_PAGE.replace(':appId', this.props.app.id)}>
                                <IconButton
                                    style={style.float.right}
                                    tooltip={this.props.t('settings_page.new_element')}
                                    tooltipPosition='top-center'
                                >
                                    <ContentAdd color={white}/>
                                </IconButton>
                            </Link>
                        </Subheader>

                        {content}
                    </List>
                </Paper>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        app: state.apps.currentApplication,
        user: state.auth.content,
        loading: state.reportsubjects.pending,
        sending: state.reportsubjects.sending,
        reportSubjects: state.reportsubjects.content
    };
}

export default connect(mapStateToProps, {
    deleteReportSubject,
    getReportSubjects
})(withTranslation(SmartReportSubjectList));



// WEBPACK FOOTER //
// src/components/report/SmartReportSubjectList/SmartReportSubjectList.js